{
  "file": "File",
  "folder": "Folder",
  "file_name": "File name",
  "folder_name": "Folder name",
  "invoice_status": "Invoice_status",
  "upload_file": "Upload file",
  "create_folder": "Create folder",
  "file_size": "File size",
  "accepted": "Accepted files",
  "any": "Any",
  "drag": "Drag",
  "or": "or",
  "browse_files": "Browse files",
  "file_submit": "Submit file",
  "order": "Order",
  "field_required": "Field is required",
  "is_signed": "Is contract signed ?",
  "add_contract": "Add contract file",
  "add_first_payment": "Add first payment",
  "add_file": "Add file",
  "file_ext_error": "We don't support this file type for the moment"
}
